/* eslint-disable */
<template>
  <div class="clients">
    <AdminNavigation ref="navigation" indexProps="2" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Clients ({{ totalCount }})</h1></div>
        <div class="header-sub-title">Click to view the details of a client, view a list of cases, or add a booking to a client. You can also click through to the client in Zoho.</div>
      </div>
    </div>
    <div class="panel">
      <AdminClientsMenu :key="clientMenuIndex" :indexProps="clientMenuIndex" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <v-btn class="add-icon right-float-element" dark>
              <router-link :to="{ name: 'admin-manage-client', query: {} }">Add New</router-link>
            </v-btn>
            <div class="d-flex align-items-center justify-content-end">
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Client Name" v-model="listParam.ClientName" />
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Branch Name" v-model="listParam.BranchName" />
              <el-input style="max-width: 200px" class="mr-1"  @input="search()" clearable placeholder="Contact Name" v-model="listParam.ContactName" />
            </div>
          </div>
        </div>

        <div class="content-scroll-x">
          <div>
            <el-table  @row-click="openClient" :default-sort="{prop: 'ClientID', order: 'descending'}" :data="clients" stripe @sort-change="sortParam" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
              <el-table-column
                  width="80"
                  show-overflow-tooltip
                  label="ID"
                  sortable="custom"
                  prop="ClientID"
              >
              </el-table-column>
              <el-table-column
                  width="180"
                  show-overflow-tooltip
                  label="Name"
                  sortable="custom"
                  prop="ClientName"
              >
                <template slot-scope="scope">
                  <span>{{scope.row.ClientName && decodeURIComponent(scope.row.ClientName)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="180"
                  show-overflow-tooltip
                  label="Branch Name"
                  sortable="custom"
                  prop="BranchName"
              >
                <template slot-scope="scope">
                  <span>{{scope.row.BranchName && decodeURIComponent(scope.row.BranchName)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  label="Address"
                  prop="BranchName"
              >
                <template slot-scope="scope">
                  <span>{{getFullAddress(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="180"
                  show-overflow-tooltip
                  label="Branch Admins"
                  prop="BranchName"
              >
                <template slot-scope="scope">
                  <span>{{getFullAddress(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label="Contacts"
                  prop="ClientContacts"
              >
                <template slot-scope="scope">
                  <span class="cursor-pointer" @click="toContact(scope)">{{scope.row.ClientContacts.map(x => decodeURIComponent(x.ClientContactFullName)).join(", ")}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="100"
                  show-overflow-tooltip
                  label="Active"
                  prop="ClientContacts"
              >
                <template slot-scope="scope">
                  <div @click.stop="() => {}" >
                    <div :ref="`loading-spinner-` + scope.$index" style="width: fit-content">
                      <el-switch active-color="#13ce66"
                                 inactive-color="#E0E0E0" @change="onChangeUserActive(scope)" :value="!!scope.row.Active" />
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  label=""
                  width="150"
                  prop="ClientContacts"
              >
                <template slot-scope="scope">
                  <div class="icon-group"  @click.stop="">
                    <!-- <router-link :to="{ name: 'admin-create-new-booking', query: { caseId: this.singleCase.id }}" -->
                    <router-link :to="{ name: 'admin-cases', query: { id: scope.row.ClientID }}"><img data-toggle="tooltip" data-placement="right" title="Cases" src="@/assets/images/case_dark_icon.svg"/></router-link>
                    <router-link :to="{ name: 'admin-search-specialist', query: { clientId: scope.row.ClientID } }"><img data-toggle="tooltip" data-placement="right" title="Add Booking" src="@/assets/images/add_booking_dark_icon.svg"/></router-link>
                    <a :href="scope.row.ZohoLink" target="_blank"><img data-toggle="tooltip" data-placement="right" title="View on Zoho" src="@/assets/images/zoho_icon.svg"/></a>
                    <EditZohoLinkDialog @updateSuccess="updateSuccess" :id="scope.row.ClientID" :index="scope.$index" type="client" />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" :key="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import AdminNavigation from '@/components/AdminNavigation'
  import Header from '@/components/Header'
  import AdminClientsMenu from '@/components/AdminClientsMenu'
  import { debounce } from 'lodash'
  import EditZohoLinkDialog from "@/components/dialog/EditZohoLinkDialog";
  export default {
    name: 'AdminClients',
    props: ["searchOptionClientProps", "searchOptionContactProps"],
    components: {
      AdminNavigation,
      Header,
      AdminClientsMenu,
      EditZohoLinkDialog
    },
    data() {
      return {
        fetchedData: false,
        hasError: false,
        successMessage: '',
        errorMessage: '',
        clients: [],
        allClients: [],
        limit: 20,
        pagination: utilities.initPagination(),
        clientsNumber: 0,
        searchTerm: '',
        totalCount: 0,
        clientMenuIndex: 0,
        loadingActive: false,
        listParam: {
          pageSize: 10,
          pageNum: 1,
          orderBy: 'ClientID',
          ContactName: null,
          ClientName: null,
          BranchName: null,
          ascOrDesc: 'DESC'
        },
        byName: false,
        byBranch: false,
        byId: false,
      }
    },
    methods: {
      async onChangeUserActive(scope) {
        this.$confirm({
          content: `You are about to ${scope.row.Active ? 'deactivate' : 'reactivate'} this client. Are you sure you want to proceed?`,
          type: 'warning',
          onConfirm: async () => {
            const loading = this.$loading({
              lock: true,
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0)',
              customClass: 'small-loading-spinner',
              target: this.$refs['loading-spinner-' + scope.$index]
            });
            if (!scope.row.Active) {
              await utilities.deActiveClient(scope.row.ClientID, {Action: 'Activate'})
              scope.row.Active = 1
            } else {
              await utilities.deActiveClient(scope.row.ClientID, {Action: 'Deactivate'})
              scope.row.Active = 0
            }
            loading.close();
          }
        })
      },
      toContact(scope) {
        this.$router.push('/admin-client-contacts?clientId=' + scope.row.ClientID)
      },
      getFullAddress(client) {
        var fullAddress = utilities.addComma(client.AddressLine1) + utilities.addComma(client.AddressLine2) + utilities.addComma(client.City) + (client.Postcode != '' ? utilities.addComma(client.State) : client.State) + client.Postcode
        return decodeURIComponent(fullAddress.trim())
      },
      sortParam( v ) {
        this.listParam.orderBy = v.prop
        if(v.order === "ascending") {
          this.listParam.ascOrDesc = 'ASC'
        } else if (v.order === "descending") {
          this.listParam.ascOrDesc = 'DESC'
        } else {
          this.listParam.orderBy = null
          this.listParam.ascOrDesc = null
        }

        this.selectPage(1)
      },
      search: debounce(function(){
        this.selectPage(1)
      },800),
      selectPage(index) {
        this.listParam.pageNum = index
        this.loadClients()
      },
      sortId(v) {
        this.listParam.orderBy = v
        this.listParam.pageNum = 1
        this.loadClients()
      },
      updateSuccess(index, newLink) {
        let obj = _.cloneDeep(this.clients[index])
        obj.ZohoLink = newLink
        this.$set(this.clients, index, obj)
        this.$forceUpdate()
      },
      openSearchClient() {
        this.$refs.navigation.$refs.globalSearch.openSearchClient()
      },
      openSearchClientContact() {
        this.$refs.navigation.$refs.globalSearch.openSearchClientContact()
      },
      openClient(row) {
        this.$router.push({ name: 'admin-manage-client', query: { id: row.ClientID } })
      },
      paging(clients) {
        utilities.disposeTooltip()
        if (clients.length == 0 || clients.length <= this.limit) {
          this.clients = clients
          $('.pagination').hide()
        } else {
          this.pagination = utilities.loadPagination(clients, this.limit)
          this.clients = this.pagination.list[this.pagination.current]
          $('.pagination').show()
        }
        this.clientsNumber = clients.length
        utilities.initTooltip()
        utilities.hoverTooltip()
      },
      async searchClient(searchOption) {
        await this.$store.dispatch('loading/setLoadComponent', true)
        this.listParam = {
          ...this.listParam,
          ...searchOption
        }
        this.clients = []
        var {clients, total} = await utilities.getClientsNew(this.listParam)
        this.clients = _.cloneDeep(clients)
        this.totalCount = total
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
      async searchClientContact(searchOption) {
        await this.$store.dispatch('loading/setLoadComponent', true)
        var params = {
          Name: searchOption.name,
        }
        this.clients = []
        var clients = await utilities.getSearchClientContacts(params)
        this.allClients = _.cloneDeep(clients)
        this.paging(clients)
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
      async loadClients() {
        await this.$store.dispatch('loading/setLoadComponent', true)
        const {clients, total} = await utilities.getClientsNew(this.listParam)
        this.clients = _.cloneDeep(clients)
        this.totalCount = total
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
    },
    async beforeMount() {
      if(this.searchOptionClientProps !== undefined) {
        await this.searchClient(this.searchOptionClientProps)
      } else if(this.searchOptionContactProps !== undefined) {
        await this.searchClientContact(this.searchOptionContactProps)
      } else {
        await this.loadClients()
      }
      this.fetchedData = true

    },
    mounted() {
      $(".pagination").hide()
    },
  }
</script>
